module.exports = __webpack_public_path__ + "img/PXL_20230524_184556417.4669c597.jpg";